import { Col, Row } from 'react-bootstrap';
import FilterContainer from '../../FilterContainer/FilterContainer';
import {
  hasPermission,
  isBroker,
  isBrokerOrganisation,
  isOwner,
} from '../../../../auth/redux/authActions';
import AsyncSelectMenu from '../../../../../common/components/SelectMenu/AsyncSelectMenu';
import React, { useState } from 'react';
import StatusFilter from '../../StatusFilter/StatusFilter';
import Icon from '../../../../../common/components/Icon/Icon';
import cx from 'classnames';
import './AdditionalFilters.scss';

const Filters = ({ show, onFilterUpdate, colSize }) => {
  if (!show) {
    return null;
  }

  const handleUserUpdate = (option) => {
    onFilterUpdate(option?.value ?? '', 'user');
  };

  const handleStatusFilterUpdate = (option) => {
    onFilterUpdate(option?.value ?? '', 'status');
  };
  const handleBrokerUpdate = (option) => {
    onFilterUpdate(option?.value ?? '', 'broker');
  };

  const handleSourceUpdate = (option) => {
    onFilterUpdate(option?.value ?? '', 'source');
  };

  const handleChannelUpdate = (option) => {
    onFilterUpdate(option?.value ?? '', 'channel');
  };

  return (
    <div className={'animated fadeIn'}>
      <Row>
        {(isOwner() || isBroker() || isBrokerOrganisation()) &&
          hasPermission('user.view') && (
            <Col sm={colSize}>
              <FilterContainer label={'User'}>
                <AsyncSelectMenu
                  url={'/users?'}
                  optionValuePath={'id'}
                  labelPath={'attributes.full_name'}
                  onChangeCallback={handleUserUpdate}
                  isClearable
                />
              </FilterContainer>
            </Col>
          )}
        {hasPermission('policy.renew') && (
          <Col sm={colSize}>
            <FilterContainer label={'Status'}>
              <StatusFilter
                onChange={handleStatusFilterUpdate}
                policyFilter
                isClearable
              />
            </FilterContainer>
          </Col>
        )}
        {isBrokerOrganisation() && hasPermission('broker.view ') && (
          <Col sm={colSize}>
            <FilterContainer label={'Branch'}>
              <AsyncSelectMenu
                url={'/brokers?'}
                optionValuePath={'id'}
                onChangeCallback={handleBrokerUpdate}
                isClearable
              />
            </FilterContainer>
          </Col>
        )}
      </Row>
      <Row>
        {isOwner() && hasPermission('broker.view') && (
          <Col sm={4}>
            <FilterContainer label={'Broker'}>
              <AsyncSelectMenu
                url={'/brokers?'}
                optionValuePath={'id'}
                onChangeCallback={handleBrokerUpdate}
                isClearable
              />
            </FilterContainer>
          </Col>
        )}
        {isOwner() &&
          (hasPermission('marketing.source_view_owner') ||
            hasPermission('marketing.source_view')) && (
            <Col sm={4}>
              <FilterContainer label={'Source'}>
                <AsyncSelectMenu
                  url={'/select-sources?'}
                  source={'select-sources'}
                  onChangeCallback={handleSourceUpdate}
                  optionValuePath={'id'}
                  isClearable
                />
              </FilterContainer>
            </Col>
          )}
        {isOwner() && hasPermission('marketing.source_view') && (
          <Col sm={4}>
            <FilterContainer label={'Channel'}>
              <AsyncSelectMenu
                url={'/channels?'}
                onChangeCallback={handleChannelUpdate}
                optionValuePath={'id'}
                isClearable
              />
            </FilterContainer>
          </Col>
        )}
      </Row>
    </div>
  );
};

const AdditionalFilters = ({ onFilterUpdate, colSize }) => {
  const [show, setShow] = useState(false);
  const toggleShow = () => {
    setShow(!show);
  };

  return (
    <div className={'additional-filters'}>
      <Row>
        <Col sm={4} onClick={toggleShow}>
          <div
            className={cx('additional-filters--header', {
              'additional-filters--show': show,
              'additional-filters--hide': !show,
            })}
          >
            <span className={'additional-filters--title'}> Additional Filters</span>
            <Icon name={show ? 'minus-circle' : 'plus-circle'} />
          </div>
        </Col>
      </Row>
      <Filters show={show} onFilterUpdate={onFilterUpdate} colSize={colSize} />
    </div>
  );
};

export { AdditionalFilters };
